import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import cfg from '../store/config';
import {isActiveToken} from '@/mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import Orders from "../views/Orders/Orders.vue";
import Stats from "../views/Stats/Stats.vue";
import Users from "../views/Users/List.vue";
import Settings from "../views/Settings/Settings.vue";
import SaudiAccounts from '@/views/Settings/SaudiAccounts.vue';


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/orders';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: Orders,
          meta: {
            access: ['superadmin', 'client'],
            title: 'Список заявок',
          }
        },
        {
          path: 'orders',
          name: 'Orders',
          beforeEnter: ifAuthenticated,
          component: Orders,
          meta: {
            access: ['superadmin', 'client'],
            title: 'Список заявок',
          }
        },
        {
          path: 'users',
          name: 'Users',
          beforeEnter: ifAuthenticated,
          component: Users,
          meta: {
            access: ['superadmin'],
            title: 'Список пользователей',
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: ifAuthenticated,
          component: Settings,
          meta: {
            access: ['superadmin'],
            title: 'Настройки',
          }
        },
        {
          path: 'stats',
          name: 'Stats',
          beforeEnter: ifAuthenticated,
          component: Stats,
          meta: {
            access: ['superadmin'],
            title: 'Статистика',
          }
        },
        {
          path: 'saudi-accounts',
          name: 'SaudiAccounts',
          beforeEnter: ifAuthenticated,
          component: SaudiAccounts,
          meta: {
            access: ['superadmin'],
            title: 'Аккаунты Saudi',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});

let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
